<template>
  <v-row id="bill-report-export">
    <v-col cols="12" md="6" sm="7">
      <v-card class="card-block">
        <h3>Export Bill Data</h3>

        <div v-if="exportBill.complete" class="select-block">
          <v-alert
            outlined
            type="success"
            text
          >
            <div>
              Your report will be available in your downloads section shortly
            </div>
            <div style="margin-top: 10px;">
              <v-btn
                @click="resetExport"
                class="ma-2"
                color="green"  role="link">
                Run Further Export
              </v-btn>
            </div>
          </v-alert>
        </div>

        <div v-if="!exportBill.complete" class="select-block">
          <date-range-picker
            ref="exportBill"
            :locale-data="{
                      firstDay: 1,
                      format: 'DD-MM-YYYY HH:mm:ss'
                    }"
            v-model="exportBill.dateRange"
            :auto-apply="true"
          >
            <div
              slot="input"
              slot-scope="exportBill"
              style="min-width: 350px;"
            >
                      <span v-if="!exportBill.startDate"
                      >Click to choose date range</span
                      >
              <span v-if="exportBill.startDate"
              >{{ exportBill.startDate | dateFormat('DD/MM/YYYY') }} -
                        {{ exportBill.endDate | dateFormat('DD/MM/YYYY') }}</span
              >
            </div>
          </date-range-picker>

          <v-row >
            <v-col cols="8">
              <v-radio-group
                v-model="exportBill.selectedDateType"
                :options="exportBill.typeOptions"
                row
              >
                <v-radio
                  :key="i"
                  v-for="(item, i) in exportBill.typeOptions"
                  :label="item.name"
                  :value=item.item
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-switch
            v-model="exportBill.includeCredits"
            color="secondary"
            label="Include credits"
          ></v-switch>

          <v-switch
            v-model="exportBill.includeFees"
            color="secondary"
            label="Include fees"
            class="mt-0"
          ></v-switch>


          <div style="margin-top: 10px;">
            <v-btn
              v-if="exportBill.dateRange.startDate"
              @click="exportMeters"
              class="ma-2"
              color="green"  role="link">
              Export
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-col>

  </v-row>
</template>

<script>
import Vue from "vue";

import DateRangePicker from "vue2-daterange-picker";

import {date} from "@/mixins/date";

Vue.component("DateRangePicker", DateRangePicker);
export default {
  name: "CreditBillingBillExport",
  mixins: [
    date
  ],
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    exportBill: {
      startDate: "",
      endDate: "",
      dateRange: {},
      loading: false,
      complete: false,
      allReads: 0,
      selectedDateType: 'consumption',
      typeOptions: [
        { item: 'invoice', name: 'Bills by Invoice Date' },
        { item: 'consumption', name: 'Bills by Consumption Date' },
      ],
      includeCredits: true,
      includeFees: true,
    }
  }),
  methods: {
    resetExport() {
      this.exportBill.startDate = "";
      this.exportBill.endDate = "";
      this.exportBill.dateRange.startDate = null;
      this.exportBill.dateRange.endDate = null;
      this.exportBill.loading = false;
      this.exportBill.complete = false;
      this.exportBill.includeCredits = true;
      this.exportBill.includeFees = true;
    },
    async exportMeters() {
      const developmentRef = this.id;
      let from = this.exportBill.dateRange.startDate;
      let to = this.exportBill.dateRange.endDate;
      const shouldExcludeCredits = !this.exportBill.includeCredits;
      const shouldExcludeFees = !this.exportBill.includeFees;
      const exportType = this.exportBill.selectedDateType;

      if (!from || !to) {
        await this.$store.dispatch("notification/triggerError", { detail: "Please select at least one bill or credit" });
        return;
      }

      from = this.formatDate(from);
      to = this.formatDate(to);

      await this.$store.dispatch("loader/loaderInitiate", { title: "Requesting Download" });

      const isSuccess = await this.$store.dispatch("downloads/requestBillData", {developmentRef, from, to, shouldExcludeCredits, shouldExcludeFees, exportType});

      if (isSuccess) {
        this.exportBill.complete = true;
        await this.$store.dispatch("notification/triggerSuccess", { detail: "Your file will be available from your downloads page shortly", title: "Download requested" });
      }

      await this.$store.dispatch("loader/loaderCancel");
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  text-align: left;
  margin-bottom: 20px;
}

.select-block {
  text-align: left;
}

.card-block {
  padding: 30px;
}
</style>
